"use client";

/**
 * The "Select this folder" affordance, shown when a caller is using the browser
 * as a folder PICKER rather than a viewer.
 *
 * It names the folder currently being browsed, and is unavailable when there is
 * no folder id to report — picking null is not picking a folder.
 */

import React from "react";
import { Upload } from "lucide-react";
import { Button } from "@west-tennessee-consulting/ui";

export function GoogleDriveFolderPickerBar({
  folderName,
  folderId,
  onPick,
}: {
  folderName: string;
  folderId: string | undefined;
  onPick: (folderId: string, folderName: string) => void;
}) {
  return (
    <div className="mb-3 flex items-center justify-between gap-2 rounded-md border bg-muted/40 px-3 py-2">
      <span className="text-sm text-muted-foreground truncate">
        Selected folder: <span className="font-medium text-foreground">{folderName}</span>
      </span>
      <Button
        type="button"
        size="sm"
        onClick={() => {
          if (folderId) onPick(folderId, folderName);
        }}
        disabled={!folderId}
      >
        Select this folder
      </Button>
    </div>
  );
}

/** Drop overlay for the drag-upload zone. */
export function GoogleDriveDropOverlay() {
  return (
    <div className="pointer-events-none absolute inset-0 z-raised flex flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-primary bg-primary/5 text-primary">
      <Upload className="h-8 w-8" />
      <span className="text-sm font-medium">Drop files to upload here</span>
    </div>
  );
}
